export type WalletEvent =
	| { name: 'wallet.detected'; type: string }
	| { name: 'wallet.click.apple' }
	| { name: 'wallet.click.google' }
	| { name: 'wallet.click.openInSafari' }
	| { name: 'wallet.fail.unsupported' };

export function track(event: WalletEvent) {
	try {
		// Google Tag Manager / dataLayer if available
		// @ts-ignore
		if (window && (window as any).dataLayer && Array.isArray((window as any).dataLayer)) {
			(window as any).dataLayer.push({ event: event.name, ...(event as any) });
			return;
		}
		// Fallback: CustomEvent for app-level listeners
		if (window && window.dispatchEvent) {
			window.dispatchEvent(new CustomEvent(event.name, { detail: event }));
		}
		// Always log for local debugging
		// eslint-disable-next-line no-console
		console.debug('[analytics]', event);
	} catch (e) {
		// ignore analytics errors
	}
}


